




























import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { requiredRule } from "@/lib/rules/requiredRule";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Ref, Prop } from "vue-property-decorator";
import DocumentForm from "./DocumentForm.vue";
import { IReference } from "@/models/reference.entity";
import { ITag } from "@/models/tag.entity";
import { SignDocument, ISignDocument } from "@/models/sign-document.entity";

@Component({
  components: { ConfirmActionDialog, DocumentForm }
})
export default class SignDocumentCreateDialog extends DarkModeHighlightMixin {
  @Ref("signDocumentForm")
  signDocumentForm!: DocumentForm;

  @Prop({ default: [] })
  refs!: IReference[];

  @Prop({ default: false })
  hideButton!: boolean;

  @Prop({ default: [] })
  tags?: ITag[];

  isDialogActive = false;
  isValid = false;
  isLoading = false;

  closeDialog() {
    this.isDialogActive = false;
  }

  get requiredRule() {
    return requiredRule();
  }

  get partner() {
    return PartnerModule.partner;
  }

  show() {
    this.isDialogActive = true;
    const tags = this.tags || [];
    if (tags.length > 0) {
      this.$nextTick(() => {
        this.signDocumentForm.setTags(tags);
      });
    }
  }

  showWithDocument(document: ISignDocument) {
    this.isDialogActive = true;
    this.$nextTick(() => {
      this.signDocumentForm.resetForm();
      if (document.file) {
        this.signDocumentForm.setFile(document.file);
      }
      if (document.name) {
        this.signDocumentForm.createDocumentDto.name = document.name;
      }
      if (document.title) {
        this.signDocumentForm.createDocumentDto.title = document.title;
      }
      if (document.folder) {
        this.signDocumentForm.createDocumentDto.folder = document.folder;
      }
      if (document.description) {
        this.signDocumentForm.createDocumentDto.description = document.description;
      }
      if (document.tags && document.tags.length > 0) {
        this.signDocumentForm.setTags(document.tags);
      }
    });
  }

  async save() {
    this.isLoading = true;
    try {
      const document = this.signDocumentForm.createDocumentDto;

      this.$log.debug(document);

      const doc = await new SignDocument({ partnerId: this.partner._id, refs: this.refs, ...document }).create();
      if (doc.id) {
        this.$emit("save", doc);
        this.$toast.success("👍");
        this.closeDialog();
      }
    } catch (error) {
      this.$log.error(error);
      this.$toast.error(this.$t("views.fleet.EventCard.error"));
    } finally {
      this.isLoading = false;
    }
  }
}
